import { render, staticRenderFns } from "./RejectFileCompany.vue?vue&type=template&id=de6a48e8&"
import script from "./RejectFileCompany.vue?vue&type=script&lang=js&"
export * from "./RejectFileCompany.vue?vue&type=script&lang=js&"
import style0 from "./RejectFileCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports